import React from 'react';
import { Box, Typography, Tooltip } from '@mui/material';
import { useDropzone } from 'react-dropzone'; // For file uploads

const BackgroundImageUpload = ({ onUpdateBackgroundImage, assets }) => {
  // Handle BG image upload
  const { getRootProps, getInputProps } = useDropzone({
    accept: 'image/*',
    onDrop: (acceptedFiles) => {
      const file = acceptedFiles[0];
      const reader = new FileReader();
      reader.onload = () => {
        onUpdateBackgroundImage(reader.result); // Pass the BG image to the parent
      };
      reader.readAsDataURL(file);
    },
  });

  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        gap: 1,
        mt: 2, // Add margin to separate from the character list
      }}
    >
      <Tooltip title="Upload BG Image" arrow>
        <Box
          {...getRootProps()}
          sx={{
            width: 100,
            height: 56,
            backgroundColor: 'rgba(0, 0, 0, 0.2)',
            borderRadius: 1,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            cursor: 'pointer',
            backgroundImage: assets.backgroundImage ? `url(${assets.backgroundImage})` : 'none',
            backgroundSize: 'cover',
            backgroundPosition: 'center',
          }}
        >
          <input {...getInputProps()} />
          {!assets.backgroundImage && (
            <Typography variant="body2" color="textSecondary">
              Upload BG
            </Typography>
          )}
        </Box>
      </Tooltip>
      <Typography variant="body1">BG Image</Typography>
    </Box>
  );
};

export default BackgroundImageUpload;